
//第三方app挂载，从流程待办列表开始展示
import workflowFormRouter from '../router/workflowFormRouter'
import XSJFeeRouter from '../router/XSJFeeRouter'
export default
    {
        path: "/listProcess",
        component: () => import('../view/processlistview/index.vue'),
        children: [
            {
                path: "UndealProcessList",

                component: () => import('../view/processlistview/UndealProcessListView.vue'),
                props: (route) => (
                    {
                        token:route.query.token,
                        sapId:route.query.sapId,
                        koaToken:route.query.koaToken,
                        userId:route.query.userId,
                        deviceType:route.query.deviceType,
                        deviceName:route.query.deviceName,
                        secondLoginType:route.query.secondLoginType,
                        secondAssessToken:route.query.secondAssessToken,
                        deviceId:route.query.deviceId,
                        OidcAuthorizationMode:route.query.OidcAuthorizationMode,
                        OidcAuthorization:route.query.OidcAuthorizationMode
                    }
                ),
                
            },
            {
                path: "mainListView",
                
                component: () => import('../view/processlistview/mainListView.vue'),
                
                props: (route) => (
                    {
                        token:route.query.token,
                        sapId:route.query.sapId,
                        koaToken:route.query.koaToken,
                        userId:route.query.userId,
                        deviceType:route.query.deviceType,
                        deviceName:route.query.deviceName,
                        st:route.query.st,
                        newVersion:route.query.newVersion,
                        secondLoginType:route.query.secondLoginType,
                        secondAssessToken:route.query.secondAssessToken,
                        deviceId:route.query.deviceId,
                        OidcAuthorizationMode:route.query.OidcAuthorizationMode,
                        OidcAuthorization:route.query.OidcAuthorization
                    }
                ),
                children:[
                    {
                        path: "workflow",
                        component: () => import('../view/workflow/WorkflowFormMain.vue'),
                        children: [
                            workflowFormRouter,
                            XSJFeeRouter
                        ]
                
                    },
                    {
                        path: "SearchProcessListView",
                        name: "SearchProcessListView",
                        component: () => import('../view/processlistview/SearchProcessListView.vue'),
                        props: (route) => (
                            {
                                token:route.query.token,
                                sapId:route.query.sapId,
                                koaToken:route.query.koaToken,
                                userId:route.query.userId,
                                deviceType:route.query.deviceType,
                                deviceName:route.query.deviceName,
                                secondLoginType:route.query.secondLoginType,
                                secondAssessToken:route.query.secondAssessToken,
                                deviceId:route.query.deviceId,
                                searchType:route.query.searchType,
                                OidcAuthorizationMode:route.query.OidcAuthorizationMode,
                                OidcAuthorization:route.query.OidcAuthorizationMode
                            }
                        ),
                        children:[
                            {
                                path: "workflow",
                                component: () => import('../view/workflow/WorkflowFormMain.vue'),
                                children: [
                                    workflowFormRouter
                                ]
                        
                            }
                        ]
                    },
                    {
                        path: "BatchHandle",
                        name: "BatchHandle",
                        component: () => import('../view/processlistview/BatchHandle.vue'),
                        props: (route) => (
                            {
                                token:route.query.token,
                                sapId:route.query.sapId,
                                koaToken:route.query.koaToken,
                                userId:route.query.userId,
                                deviceType:route.query.deviceType,
                                deviceName:route.query.deviceName,
                                st:route.query.st,
                                secondLoginType:route.query.secondLoginType,
                                secondAssessToken:route.query.secondAssessToken,
                                deviceId:route.query.deviceId,
                                newVersion:route.query.newVersion,
                                OidcAuthorizationMode:route.query.OidcAuthorizationMode,
                                OidcAuthorization:route.query.OidcAuthorizationMode
                                
                            }
                        ),
                        children:[
                            {
                                path: "workflow",
                                component: () => import('../view/workflow/WorkflowFormMain.vue'),
                                children: [
                                    workflowFormRouter
                                ]
                        
                            }
                        ]
                    },
                    {
                        path: "SearchDoneProcessListView",
                        name: "SearchDoneProcessListView",
                        component: () => import('../view/processlistview/SearchDoneProcessListView.vue'),
                        props: (route) => (
                            {
                                token:route.query.token,
                                sapId:route.query.sapId,
                                koaToken:route.query.koaToken,
                                userId:route.query.userId,
                                deviceType:route.query.deviceType,
                                deviceName:route.query.deviceName,
                                secondLoginType:route.query.secondLoginType,
                                secondAssessToken:route.query.secondAssessToken,
                                deviceId:route.query.deviceId,
                                searchType:route.query.searchType,
                                OidcAuthorizationMode:route.query.OidcAuthorizationMode,
                                OidcAuthorization:route.query.OidcAuthorizationMode
                            }
                        ),
                        children:[
                            {
                                path: "workflow",
                                component: () => import('../view/workflow/WorkflowFormMain.vue'),
                                children: [
                                    workflowFormRouter
                                ]
                        
                            }
                        ]
                    }
                ]
            },
            
            
        ]

    }



// WEBPACK FOOTER //
// ./src/router/listviewRouter.js